import React from "react";
import OfferDataPrices from "../../../data/OfferDataPrices";

function OfferPriceGrid() {
  return (
    <div className="row d-flex p-0 pl-1 m-0 justify-content-center align-items-center">
      <p className="page-title col-12 text-center">Nasza Oferta</p>
      {OfferDataPrices.map(({ title, description, prices }) => (
        <div key={title} className="col-sm-6 p-2">
          <div className="offer-price-panel p-4 d-flex flex-column justify-content-center align-items-center">
            <div className="row flex-column align-items-center justify-content-center mb-3">
              <h3 className="offer-price-title text-center mb-1">{title}</h3>
              <p className="offer-price-description text-center mb-0">{description}</p>
            </div>
            <div className="row justify-content-center">
              {prices.map(({ duration, price }) => (
                <div key={`${title}-${duration}-${price}`} className="col-12 row justify-content-around m-0 p-0 mt-2">
                  <div className="offer-price-text p-0 col-6 d-flex justify-content-center">
                    {duration.replace(/ /g, "\u00A0")}
                  </div>
                  <div className="offer-price-text p-0 col-6 d-flex justify-content-center">
                    {price.replace(/ /g, "\u00A0")}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
      <p className="offer-price-note col-12 text-center">
        Ceny zajęć dla 2–6 osób podane są za jedną osobę. Stawka zależy od liczby uczestników zapisanych do grupy
        w danym miesiącu i nie zmienia się z powodu pojedynczej nieobecności. Zmiana stałej liczebności grupy wpływa
        na cenę od kolejnego miesiąca.
      </p>
      <p className="offer-price-note col-12 text-center">
        Ceny podane są w złotych polskich i obejmują wszystkie standardowe koszty zajęć. Materiały edukacyjne,
        książki lub dostępy do platform mogą być rozliczane osobno, jeżeli wynika to z oferty lub umowy.
      </p>
    </div>
  );
}

export default OfferPriceGrid;
